// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export var ERoomType = /*#__PURE__*/function (ERoomType) {
  /** Пятикомнатная квартира **/
  ERoomType["FiveRoom"] = "fiveRoom";
  /** Четырехкомнатная квартира **/
  ERoomType["FourRoom"] = "fourRoom";
  /** Многокомнатная квартира (6 и более комнат) **/
  ERoomType["Large"] = "large";
  /** Однокомнатная квартира **/
  ERoomType["OneRoom"] = "oneRoom";
  /** Квартира со свободной планировкой **/
  ERoomType["OpenPlan"] = "openPlan";
  /** Студия **/
  ERoomType["Studio"] = "studio";
  /** Трехкомнатная квартира **/
  ERoomType["ThreeRoom"] = "threeRoom";
  /** Двухкомнатная квартира **/
  ERoomType["TwoRoom"] = "twoRoom";
  return ERoomType;
}({});